// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"f0935233","399":"8ae876c1","542":"341c09fa","643":"0fcf11c7","674":"bb8c2c79","787":"e7ca48cd"}[chunkId] + ".chunk.js";
};